import React from 'react';
import PropTypes from 'prop-types';
import { Columns, Column } from 'src/ui/mui-ui-kit';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import {
  // AddressPickerAdapter,
  UiFieldset,
  UiInputAdapter,
  UiSelectAdapter,
  UiToggleAdapter,
} from '../../ui';
import { usStates } from '../../core';
import { ZIP_MASK } from '../../ui/const';
import { titleToCamelCase } from '../utils';
import { required } from '../../ui/validations';

export const AddressForm = ({ name, useSameAs, values }) => {
  const id = titleToCamelCase(name);
  const isDisabled = useSameAs && values.addressSameAsAbove;
  const maybeRequired = fieldName => (value, values) =>
    useSameAs && values.addressSameAsAbove
      ? undefined
      : required(fieldName)(value);
  return (
    <UiFieldset title={name}>
      <Columns isMultiline>
        {useSameAs && (
          <Column isSize="full">
            <Field
              component={UiToggleAdapter}
              name="addressSameAsAbove"
              id="addressSameAsAbove"
              type="checkbox"
            >
              Same as above?
            </Field>
          </Column>
        )}
        <Column isSize="1/2" className="is-one-third-fullhd">
          <Field
            component={UiInputAdapter}
            name={`${id}.address`}
            label="Location Address"
            required={!isDisabled}
            disabled={isDisabled}
            validate={maybeRequired('Location Address')}
            className={classNames({ 'same-as-above-field': isDisabled })}
          />
        </Column>
        <Column isSize="1/2" className="is-one-third-fullhd">
          <Field
            component={UiInputAdapter}
            name={`${id}.address2`}
            label="Location Address 2"
            disabled={isDisabled}
            className={classNames({ 'same-as-above-field': isDisabled })}
          />
        </Column>

        <Column isSize="1/2" className="is-one-third-fullhd">
          <Field
            component={UiInputAdapter}
            name={`${id}.city`}
            label="City"
            required={!isDisabled}
            disabled={isDisabled}
            validate={maybeRequired('City')}
            className={classNames({ 'same-as-above-field': isDisabled })}
          />
        </Column>
        <Column isSize="1/2" className="is-one-third-fullhd">
          <Field
            component={UiSelectAdapter}
            name={`${id}.state`}
            options={usStates}
            label="State"
            required={!isDisabled}
            isDisabled={isDisabled}
            validate={maybeRequired('State')}
            fieldClassName={classNames({ 'same-as-above-field': isDisabled })}
          />
        </Column>
        <Column isSize="1/2" className="is-one-third-fullhd">
          <Field
            component={UiInputAdapter}
            name={`${id}.zipCode`}
            label="Zip Code"
            mask={ZIP_MASK}
            required={!isDisabled}
            disabled={isDisabled}
            validate={maybeRequired('Zip Code')}
            className={classNames({ 'same-as-above-field': isDisabled })}
          />
        </Column>
      </Columns>
    </UiFieldset>
  );
};
AddressForm.propTypes = {
  name: PropTypes.string.isRequired,
  useSameAs: PropTypes.bool,
  values: PropTypes.object.isRequired,
};

AddressForm.defaultProps = {
  useSameAs: false,
};
